import React from 'react';
import { DocsPageShell } from './DocsLayout';
import { getSectionsByAudience } from '../../utils/docsContent';

const studentSections = getSectionsByAudience('student');

const NAV_LINKS = [
  { to: '/docs/teacher', label: 'Teacher Guide' },
  { to: '/docs/parent', label: 'Parent Guide' },
];

export const DocsStudent = () => (
  <DocsPageShell
    title="Student Guide"
    subtitle="Learn how to use the Frankly Talking English student portal — classes, activities, chat, and more."
    sections={studentSections}
    navLinks={NAV_LINKS}
  />
);

export default DocsStudent;
